module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers clearfix",
    attrs: {
      "id": "pers-caltax",
      "name": "hres8ax-caltax"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "income-summary-box clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3 rate-topic"
  }, [_c('div', {
    staticClass: "col-sm-7 col-xs-12"
  }, [_c('div', {
    staticClass: "label-rate"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "rate color-skin"
  }, [_vm._v(_vm._s(_vm.detailCaltax.ratetax) + "% ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 col-xs-12"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 graph-box"
  }, [_c('div', {
    staticClass: "graph-1 bg-color-skin",
    class: {
      'bg-color-skin-dark-20': _vm.detailCaltax.ratetax < 5
    }
  }, [_vm._v("0%")]), _vm._v(" "), _c('div', {
    staticClass: "graph-2 bg-color-skin",
    class: {
      'bg-color-skin-dark-20': _vm.detailCaltax.ratetax >= 5 && _vm.detailCaltax.ratetax < 10
    }
  }, [_vm._v("5%")]), _vm._v(" "), _c('div', {
    staticClass: "graph-3 bg-color-skin",
    class: {
      'bg-color-skin-dark-20': _vm.detailCaltax.ratetax >= 10 && _vm.detailCaltax.ratetax < 15
    }
  }, [_vm._v("10%")]), _vm._v(" "), _c('div', {
    staticClass: "graph-4 bg-color-skin",
    class: {
      'bg-color-skin-dark-20': _vm.detailCaltax.ratetax >= 15 && _vm.detailCaltax.ratetax < 20
    }
  }, [_vm._v("15%")]), _vm._v(" "), _c('div', {
    staticClass: "graph-5 bg-color-skin",
    class: {
      'bg-color-skin-dark-20': _vm.detailCaltax.ratetax >= 20 && _vm.detailCaltax.ratetax < 25
    }
  }, [_vm._v("20%")]), _vm._v(" "), _c('div', {
    staticClass: "graph-6 bg-color-skin",
    class: {
      'bg-color-skin-dark-20': _vm.detailCaltax.ratetax >= 25 && _vm.detailCaltax.ratetax < 30
    }
  }, [_vm._v("25%")]), _vm._v(" "), _c('div', {
    staticClass: "graph-7 bg-color-skin",
    class: {
      'bg-color-skin-dark-20': _vm.detailCaltax.ratetax >= 30 && _vm.detailCaltax.ratetax < 35
    }
  }, [_vm._v("30%")]), _vm._v(" "), _c('div', {
    staticClass: "graph-8 bg-color-skin",
    class: {
      'bg-color-skin-dark-20': _vm.detailCaltax.ratetax >= 35
    }
  }, [_vm._v("35%")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3 tax-pay"
  }, [_c('div', {
    staticClass: "label-pay"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "pay color-skin"
  }, [_vm._v(_vm._s(_vm.detailCaltax.amttax) + " " + _vm._s(_vm.labels['HRES8AXC4']['60']))])])]), _vm._v(" "), _c('div', {
    staticClass: "cal-input-group clearfix"
  }, [_c('div', {
    staticClass: "cal-topic clearfix color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC4']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 "
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "label-summary"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "data-summary"
  }, [_vm._v(_vm._s(_vm.detailCaltax.amtsalyr) + " " + _vm._s(_vm.labels['HRES8AXC4']['60']))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 "
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "label-summary"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC4']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "data-summary"
  }, [_vm._v(_vm._s(_vm.detailCaltax.amtdeduct) + " " + _vm._s(_vm.labels['HRES8AXC4']['60']))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 "
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "label-summary"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "data-summary"
  }, [_vm._v(_vm._s(_vm.detailCaltax.amttax) + " " + _vm._s(_vm.labels['HRES8AXC4']['60']))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-summary"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/cal-tax/icon-4-1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-summary"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/cal-tax/icon-4-2.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-summary"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/cal-tax/icon-4-3.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9989c728!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres8ax/caltax.vue
// module id = 3931
// module chunks = 1